import PropTypes from '../../_util/vue-types';
import { ConfigConsumerProps } from '../config-provider/configConsumerProps';

export default {
  name: 'FcMessageDrawer',
  props: {
    title: PropTypes.string,
    extra: PropTypes.extra,
    visible: PropTypes.Boolean || true,
    width: PropTypes.number,
    drawerProps: PropTypes.object,
    tabsProps: PropTypes.object,
    cardsProps: PropTypes.object,
    api: {
      messageUrl: PropTypes.string,
      readerUrl: PropTypes.string,
      clearUrl: PropTypes.string,
    },
    // /** drawer 属性 */
    // drawerProps: Drawer,
    // /** tabs 属性 */
    // tabsProps: Tabs,
    // /** cards 属性 */
    // cardsProps: Card,
  },
  inject: {
    configProvider: { default: () => ConfigConsumerProps }, // 注入依赖，包含组件基本class名方法
  },
  data() {
    return {
      dataSource: [
        {
          message: '123',
        },
      ],
    };
  },
  methods: {
    onOpen() {
      this.$props.visible = true;
    },
    onClose() {
      this.$props.visible = false;
    },
    onRead() {},
    onMark() {},
    onPageChange(event) {
      this.$emit('onPageChange', event);
    },
  },
  mounted() {
    // const Req = new Request();
    // Get('http://192.168.10.177:3001/message');
  },
  render() {
    const { dataSource } = this;
    const { locale } = this.configProvider;

    /**
     * 消息列表
     */
    const messageList = (
      <div>
        <a-card title="导入通知">
          <a slot="extra" href="#">
            more
          </a>
          <p>card content</p>
          <p>card content</p>
          <p>card content</p>
        </a-card>

        <a-card title="Default size card" loading={true}>
          <a slot="extra" href="#">
            more
          </a>
          <p>card content</p>
          <p>card content</p>
          <p>card content</p>
        </a-card>
      </div>
    );

    /***
     * 分页
     */
    const pagination = (
      <div>
        <a-button slot="tabBarExtraContent" type="link" icon="left"></a-button>
        <a-input size="small" width="30" type="number" class="page-input">
          1
        </a-input>
        / 5<a-button slot="tabBarExtraContent" type="link" icon="right"></a-button>
      </div>
    );
    /**
     * 清空
     */
    const clear = (
      <div>
        <a-button type="link" icon="delete">
          {locale.Modal.clearText}
        </a-button>
      </div>
    );

    return (
      <div class="fc-message-drawer">
        <a-badge onClick={this.onOpen}>
          <a href="#" class="head-example">
            <a-icon type="notification" />
          </a>
        </a-badge>

        <a-drawer
          placement={'right'}
          closable={false}
          visible={this.$props.visible}
          onClose={this.onClose}
          width={395}
          class="fc-message-drawer"
        >
          <a-tabs default-active-key="1">
            <a-tfc-pane key="1" tab="已读">
              <div v-if={dataSource && dataSource.length > 0}>
                {clear}
                {messageList}
                {pagination}
              </div>

              <a-empty v-if={dataSource.length <= 0}></a-empty>
            </a-tfc-pane>
            <a-tfc-pane key="2" tab="未读">
              <div v-if={dataSource && dataSource.length > 0}>
                {clear}
                {messageList && messageList}
                {pagination}
              </div>

              <a-empty v-if={!dataSource || dataSource.length <= 0}></a-empty>
            </a-tfc-pane>

            <a-button slot="tabBarExtraContent" type="link" icon="file-done"></a-button>
          </a-tabs>
        </a-drawer>
      </div>
    );
  },
};
